import React, {  } from 'react'
import "./assets/styles/style.css"
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Header, S3Browser } from './components'

Amplify.configure(awsconfig)

const App = ({ signOut, user }) => {

  return (
    <div>
      <Header signOut={signOut} username={user.username}/>
      <S3Browser/>
    </div >
  );
}

export default withAuthenticator(App)
